import { useState } from 'react';
import Flatpickr from 'react-flatpickr';
import { FieldError } from "./FieldError";
export const ClientTimePicker = ({
  guid,
  className,
  format,
  style,
  defaultDate,
  update = () => {},
  required,
  readOnly,
  label = '',
  error,
  errorText
}) => {
  const [updateCount, incrementCount] = useState(0);
  const invalidClass = error && error.length ? 'invalid' : '';
  let options = {
    enableTime: true,
    noCalendar: true,
    minuteIncrement: 1,
    dateFormat: format,
    altFormat: format,
    altInput: true,
    disableMobile: true,
    time_24hr: style === 1 ? false : true,
    enableSeconds: style === 2 || style === 3 ? true : false,
    altInputClass: `${className} time-altInput ${invalidClass}`
  };
  const handleUpdate = (selectedDates, dateStr, instance) => {
    const selectedTime = selectedDates[0];
    incrementCount(updateCount + 1);
    update(selectedTime);
  };
  return <>
      <Flatpickr id={`hidden_timepicker_input-${guid}`} key={`${guid}-${defaultDate}-${style}-${updateCount}`} className={`${className} ${invalidClass}`} value={defaultDate} data-enable-time options={options} onOpen={(selectedDates, dateStr, instance) => {
      //Meh kinda method...flatpickr currently have no disable specific hours/minutes/seconds feature
      //So have to access the input's DOM to hide
      const disableHourDisplay = () => {
        instance.hourElement.parentElement.style.display = 'none';
        instance.hourElement.parentElement.nextSibling.style.display = 'none';
      };
      //Disable + hide Hour display for MM:SS style
      style == 3 ? disableHourDisplay() : '';
    }} onClose={handleUpdate} disabled={readOnly} />
      <label className={`input-fields__label`}>
        {required ? `${label}*` : `${label}`}
      </label>
      {error && <FieldError errorText={errorText} />}
    </>;
};